import type { IFAQDocument } from '../../types';
import * as m from '@/paraglide/messages.js';
import FAQSubmitClaim from '@/assets/banners/submitting-a-claim-guide-faq.jpg';
import FAQSeeDoctor from '@/assets/banners/seeing-a-doctor-guide-faq.jpg';
import FAQMentalHealth from '@/assets/banners/mental-health-guide-faq.jpg';

export const getFAQDocuments = (): IFAQDocument[] => [
  {
    title: m.faq_doc_claim_title(),
    imageSrc: FAQSubmitClaim,
    href: '/faq/documents/submittingAClaim',
    isExternal: false,
    ariaLabel: m.faq_doc_claim_aria(),
  },
  {
    title: m.faq_doc_doctor_title(),
    imageSrc: FAQSeeDoctor,
    href: '/faq/documents/seeingADoctor',
    isExternal: false,
    ariaLabel: m.faq_doc_doctor_aria(),
  },
  {
    title: m.faq_doc_mental_health_title(),
    imageSrc: FAQMentalHealth,
    href: '/faq/documents/mentalHealthAndYou',
    isExternal: false,
    ariaLabel: m.faq_doc_mental_health_aria(),
  },
];
